import { ActivatedRouteSnapshot } from '@angular/router';
import { Provisioning } from '@wsphere/warranties/domain';

export type GuardedProvisioningStep = 'policy' | 'asset' | 'plan' | 'addon' | 'checkout';

interface SessionRequirement {
  isMissing: (session: Provisioning.ProvisioningSession | null) => boolean;
  redirectPath: GuardedProvisioningStep | null;
}

const SESSION_REQUIREMENTS: Record<GuardedProvisioningStep, SessionRequirement[]> = {
  policy: [{ isMissing: session => !session?.customerId, redirectPath: null }],
  asset: [
    { isMissing: session => !session?.customerId, redirectPath: null },
    { isMissing: session => !session?.policyId, redirectPath: 'policy' },
  ],
  plan: [
    { isMissing: session => !session?.customerId, redirectPath: null },
    { isMissing: session => !session?.policyId, redirectPath: 'policy' },
    { isMissing: session => !session?.assetId && !session?.assetDraft, redirectPath: 'asset' },
  ],
  addon: [
    { isMissing: session => !session?.customerId, redirectPath: null },
    { isMissing: session => !session?.policyId, redirectPath: 'policy' },
    { isMissing: session => !session?.assetId && !session?.assetDraft, redirectPath: 'asset' },
    { isMissing: session => !session?.planId, redirectPath: 'plan' },
    { isMissing: session => !session?.policyTermId, redirectPath: 'plan' },
  ],
  checkout: [
    { isMissing: session => !session?.customerId, redirectPath: null },
    { isMissing: session => !session?.policyId, redirectPath: 'policy' },
    { isMissing: session => !session?.assetId && !session?.assetDraft, redirectPath: 'asset' },
    { isMissing: session => !session?.planId, redirectPath: 'plan' },
  ],
};

export function getProvisioningStepRedirect(
  route: ActivatedRouteSnapshot,
  session: Provisioning.ProvisioningSession | null,
  step: GuardedProvisioningStep
): string[] | null {
  for (const requirement of SESSION_REQUIREMENTS[step]) {
    if (!requirement.isMissing(session)) continue;

    const basePath = route.data['staffView'] ? '/provisioning' : '/checkout';
    return requirement.redirectPath ? [basePath, requirement.redirectPath] : [basePath];
  }

  return null;
}
